__turbopack_context__.v({
  "breadcrumb": "GR8exa_breadcrumb",
  "breadcrumbActive": "GR8exa_breadcrumbActive",
  "breadcrumbNotLast": "GR8exa_breadcrumbNotLast",
  "breadcrumbsWrapper": "GR8exa_breadcrumbsWrapper",
});
